import React, { useState, useContext, useEffect, forwardRef, useImperativeHandle } from 'react'

import { DialogContent, DialogTitle, Dialog, DialogActions, Container, TextField, InputAdornment, IconButton, ButtonGroup, LinearProgress, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {

    Grid2 as Grid,

} from '@mui/material';


import { LibraryAddCheck, CheckBoxOutlineBlank, FilterAlt, Check, Search, Edit, CheckBox, GridView, TableRows, Close } from '@mui/icons-material'
import { Box } from '@mui/system';

import { WarningIcon } from './graphicElements';
import { globalstyles } from '../lib/definitions';

//import { getProductDict, addProduct, updateProduct, getProductList } from '../dbConnector/dbProduct';


const defaultButton = (props) => {
    const element = props.element
    console.log("DEF", element)
    return (

        <>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    color: 'darkgrey',
                    position: 'relative',
                    fontSize: '12px'
                }}>
                {element.code}
            </Typography>
            <Typography
                component="div"
                variant="subtitle1"
                color="inherit"
                sx={{
                    position: 'relative',
                    fontSize: '10px'
                }}>
                {element.label}
            </Typography>
        </>

    )
}

const defaultRow = (props) => {
    const element = props.element
    return (

        <Grid container >
            {element.code &&
                <Grid size="grow">
                    <Typography
                        component="div"
                        variant="subtitle1"
                        color="inherit"
                        sx={{
                            color: 'blue',
                            position: 'relative',
                            fontSize: '12px'
                        }}>
                        {element.code}
                    </Typography>
                </Grid>
            }
            <Grid size="grow">

                <Typography
                    component="div"
                    variant="subtitle1"
                    color="inherit"
                    sx={{
                        position: 'relative',
                        fontSize: '11px'
                    }}>
                    {element.label}
                </Typography>
            </Grid>
        </Grid>
    )
}
const defaultHeader = (props) => {
    return (

        <Grid container item>
        </Grid>
    )
}
const MyButton = ({ renderButton, element }) => {
    const btn = renderButton({ element })
    return (
        <>{btn}</>

    )
}


const MyRow = ({ renderRow, element }) => {
    const row = renderRow({ element })
    return (
        row
    )
}

const MyHeader = ({ renderHeader }) => {
    const hd = renderHeader()
    return (
        <>{hd}</>
    )
}


const formatSearchData = (t) => {
    let _t = t.toLowerCase().trim()
    return (_t.split(" "))
}


const isPresent = (p, param_list, s) => {
    console.log(param_list, p)
    for (const c of param_list) {
        if (s.filter(_s => {
            const index = p[c] && (p[c] + '').toLowerCase().indexOf(_s) >= 0
            console.log(p, c, p[c] + '', _s, index)
            return index
        }).length > 0
        ) {
            return true
        }
    }
    return false

}

//-------------------------------------------
export const DialogMultiSelector = forwardRef(({ source_list, sourceFn, sourceResParam, sourceResSubparam, changeFn, elem_list, label, element, valueOnButton, renderButton, searchparam_list,
    filterparam_list, renderRow, idParam, renderHeader, newDialog, isWarning, warningLabel,
    btnLabel, firstElement }, ref) => {


    const [show, setShow] = useState(false)
    const [selectedElements, setSelectedElements] = useState(element ? element : [])
    const [filterText, setFilterText] = useState('')
    const [isEdited, setIsEdited] = useState(false)
    const [showOnlyFilter, setShowOnlyFilter] = useState(element ? true : false)
    const [autoSelect, setAutoSelect] = useState(true)
    const [filteredList, setFilteredList] = useState([])
    const [showMode, setShowMode] = useState('table')
    const [prefilterParam, setPreFilterParam] = useState([])
    const [preFilterSelected, setPreFilterSelected] = useState({})
    const [sourceList, setSourceList] = useState(source_list || [])
    const [isLoading, setIsLoading] = useState(true)
    const [isSimple, setSimple] = useState(idParam === false)
    const [c_height, setContentHeight] = useState('80vh')


    const _searchparam_list = searchparam_list || ['code', 'description', 'label']
    const myIdParam = idParam ? idParam : 'code'

    const myRenderButton = renderButton ? renderButton : defaultButton
    const myRenderRow = renderRow ? renderRow : defaultRow
    const myRenderHeader = renderHeader ? renderHeader : defaultHeader
    const myBtnLabel = btnLabel || ((element && !element[myIdParam]) ? 'Seleziona' : 'Modifica')

    useImperativeHandle(ref, () => ({
        onEdit() {
            handleShow()
        }
    }))




    const initData = async () => {

        let _filter_param = []
        let _filter_dict = {}
        let _sList = []
        if (sourceFn) {
            const c = await sourceFn()
            console.log("LIST SOURCE from DB", c)
            if (!c || c.error) {
                console.log(c.error)
            } else {
                _sList = c

                if (_sList) {
                    if (sourceResSubparam) {
                        _sList = _sList[sourceResSubparam]
                    }
                    if (firstElement) {
                        _sList = [firstElement, ..._sList]
                    }

                    setSourceList(_sList)
                }
                setIsLoading(false)
            }
            if (filterparam_list) {
                for (const f of filterparam_list) {
                    const s_list = _sList.map(s => s[f])
                    if (s_list.length > 0) {
                        const uniqueP = [...new Set(s_list)]
                        if (uniqueP.length > 1) {
                            _filter_param.push({ param: f, list: uniqueP })
                        }
                    }
                    _filter_dict[f] = []
                }

            }
            setPreFilterParam(_filter_param)
            setPreFilterSelected(_filter_dict)


        } else {
            if (source_list) {

                setSourceList(source_list)
            }
            setIsLoading(false)
            if (filterparam_list) {
                for (const f of filterparam_list) {
                    const s_list = source_list.map(s => s[f])
                    if (s_list.length > 0) {
                        const uniqueP = [...new Set(s_list)]
                        if (uniqueP.length > 1) {
                            _filter_param.push({ param: f, list: uniqueP })
                        }
                    }
                    _filter_dict[f] = []
                }

            }
            setPreFilterParam(_filter_param)
            setPreFilterSelected(_filter_dict)

        }
    }

    const handleShow = () => {
        initData()
        if (element) {
            setSelectedElements(element)
        } else {
            setSelectedElements(elem_list ? elem_list : [])
        }
        setIsEdited(false)
        setShow(true)
        //setContentHeight(contentRef.current?.clientHeight - 30)
    }
    const handleClose = () => {
        setShow(false)
    }
    const handleSave = () => {
        setShow(false)
        if (element) {
            changeFn(selectedElements)

        } else {
            if (isSimple) {
                changeFn(selectedElements)

            } else {
                console.log("OLD", elem_list)
                let _elem_list = selectedElements.map(e => {
                    const old_e = elem_list.filter(ee => ee[myIdParam] === e[myIdParam])
                    if (old_e.length > 0) {
                        return old_e[0]
                    }
                    return e
                })
                console.log("NEW", _elem_list)
                changeFn(_elem_list)

            }

        }
    }



    const handleChangeSelection = (uid) => {
        if (element) {
            setSelectedElements(uid)
        } else {
            let editList = [...selectedElements]
            let c = -1
            if (isSimple) {
                c = editList.indexOf(uid)
            } else {
                c = editList.map(e => e[myIdParam]).indexOf(uid[myIdParam])
            }
            if (c < 0) {
                editList.push(uid)
            } else {
                editList.splice(c, 1)
            }
            console.log(uid, editList)
            setIsEdited(true)
            setSelectedElements(editList)
        }
    }

    const handleSelectAll = () => {
        setIsEdited(true)
        setSelectedElements(sourceList)

    }
    const handleSelectFiltered = () => {
        setIsEdited(true)
        if (isSimple) {
            setSelectedElements(filteredList.map(e => sourceList.filter(se => se.toLowerCase() === e)[0]))
        } else {
            setSelectedElements(filteredList.map(e => sourceList.filter(se => se[myIdParam].toLowerCase() === e)[0]))
        }

    }

    const handleUnSelectAll = () => {
        setIsEdited(true)
        setSelectedElements([])
    }

    const updatePreFilter = (param, el) => {
        let _pf = [...preFilterSelected[param]]
        const c = _pf.indexOf(el)
        if (c >= 0) {
            _pf.splice(c, 1)
        } else {
            _pf.push(el)
        }
        setPreFilterSelected((pf) => ({ ...pf, [param]: _pf }))
    }

    const resetPreFilter = (param) => {
        setPreFilterSelected((pf) => ({ ...pf, [param]: [] }))
    }


    const isPreFilter = (e) => {
        let _filter_status = true
        for (const f of filterparam_list) {
            console.log(preFilterSelected[f].length === 0, preFilterSelected[f].indexOf(e[f]) >= 0)
            _filter_status = _filter_status && (preFilterSelected[f].length === 0 || preFilterSelected[f].indexOf(e[f]) >= 0)
        }
        return _filter_status
    }



    useEffect(() => {
        if (element) {
            if (sourceList && sourceList.length > 0 && show) {
                if (filterText.length > 0) {
                    const _filterText = formatSearchData(filterText)
                    const _el_list = sourceList.filter(p => isPresent(p, _searchparam_list, _filterText))
                    if (isSimple) {
                        const _sp_list = _el_list.map(p => (p + '').toLowerCase())
                        setFilteredList(_sp_list)

                    } else {

                        const _sp_list = _el_list.map(p => (p[myIdParam] + '').toLowerCase())
                        setFilteredList(_sp_list)
                    }
                    if (_el_list.length === 1) {
                        setSelectedElements(_el_list[0])
                    }
                } else {
                    setFilteredList([])
                }
            }

        } else {
            if (sourceList && sourceList.length > 0 && show) {
                if (filterText.length > 0) {
                    const _filterText = formatSearchData(filterText)
                    const _el_list = sourceList.filter(p => isPresent(p, _searchparam_list, _filterText))
                    if (autoSelect) {
                        setSelectedElements(_el_list)
                        setIsEdited(true)
                    }
                    if (isSimple) {
                        const _sp_list = _el_list.map(p => (p + '').toLowerCase())
                        setFilteredList(_sp_list)

                    } else {
                        const _sp_list = _el_list.map(p => (p[myIdParam] + '').toLowerCase())
                        setFilteredList(_sp_list)

                    }
                } else {
                    setFilteredList([])
                    if (autoSelect) {
                        setSelectedElements([])
                        setIsEdited(true)
                    }
                }
            }
        }


    }, [filterText])


    const isSelected = (sel_p) => {
        if (isSimple) {
            if (element) {
                return (selectedElements && selectedElements === sel_p)
            } else {
                return selectedElements && selectedElements.indexOf(sel_p) >= 0
            }

        } else {

            if (element) {
                return (selectedElements && selectedElements[myIdParam] === sel_p)
            } else {
                return selectedElements && selectedElements.map(m => m[myIdParam]).indexOf(sel_p) >= 0
            }
        }
    }



    const renderElementSection = (_elem) => {
        if (showMode === 'grid') {
            return (
                <Grid container spacing={1}>
                    {sourceList.filter(e =>
                        prefilterParam.length === 0 ||
                        isPreFilter(e) && (

                            !showOnlyFilter
                            || filterText.length === 0
                            || filteredList.indexOf((e[myIdParam] + '').toLowerCase()) >= 0
                        )
                    ).map((_elem, k) => (
                        <Grid item key={k} size="auto">
                            <Button
                                fullWidth={true}
                                onClick={() => handleChangeSelection(_elem)}
                                variant={(isSimple ? isSelected(_elem) : isSelected(_elem[myIdParam])) ? 'contained' : 'outlined'}
                                color="primary">
                                <Box sx={{ display: 'block' }}>
                                    <MyButton renderButton={myRenderButton} element={_elem} />
                                </Box>
                            </Button>
                        </Grid>
                    ))}

                </Grid>

            )

        } else if (showMode === 'table') {
            return (
                <>
                    <Grid container size="grow" sx={{ pb: "1px", pt: "1px", borderBottom: '1px solid darkgrey' }}>
                        <Grid size="grow">
                            <MyHeader renderHeader={myRenderHeader} />
                        </Grid>
                        <Grid item xs={1} sx={{ backgroundColor: '#aaa' }}>

                        </Grid>
                    </Grid>
                    {sourceList.filter(e => !showOnlyFilter
                        || filterText.length === 0
                        || (isSimple ? filteredList.indexOf((e + '').toLowerCase()) >= 0 : filteredList.indexOf((e[myIdParam] + '').toLowerCase()) >= 0)
                    ).map((_elem, k) => (
                        <Grid container key={k} sx={{ pb: "1px", pt: "1px", borderBottom: '1px solid darkgrey', backgroundColor: isSimple ? isSelected(_elem) : isSelected(_elem[myIdParam]) ? 'lightblue' : '' }} >
                            <Grid item size="grow">
                                <MyRow renderRow={myRenderRow} element={_elem} />
                            </Grid>
                            <Grid item size={1}>
                                <Button
                                    onClick={() => handleChangeSelection(_elem)}
                                    variant={isSimple ? isSelected(_elem) : isSelected(_elem[myIdParam]) ? 'contained' : 'outlined'}
                                    size="small"
                                    color="primary">
                                    <Check sx={{fontSize: '0.9em'}} />
                                </Button>

                            </Grid>
                        </Grid>
                    ))}
                </>
            )

        }


    }

    const updateSource = (el) => {
        console.log("update source", el)
        setSourceList((sl) => ([...sl, el]))
        if (element) {
            setSelectedElements(el)

        } else {
            setSelectedElements((sl) => ([...sl, el]))
        }
    }

    //##---------------------------------------------------------------------------------------------
    return (
        <>
            <Button onClick={handleShow} size="small" variant="outlined" ref={ref} startIcon={<Edit sx={{ fontSize: "0.8em" }} />} >
                {valueOnButton && element && element[myIdParam] ?
                    <MyButton renderButton={myRenderButton} element={element} />
                    :
                    <Typography
                        component="span"
                        variant="subtitle2"
                        color="inherit"
                        sx={{
                            fontSize: '12px',
                            fontStyle: 'italic',
                        }}
                    >
                        {myBtnLabel}
                    </Typography>
                }
                {isWarning &&
                    <WarningIcon label={warningLabel} />
                }
            </Button>




            <Dialog
                fullWidth={true}
                fullScreen={true}
                maxWidth={'xl'}
                open={show}
                onClose={handleClose}
                onKeyUp={(e) => {
                    if (e.key.toLowerCase() === 'enter') {
                        handleSave();
                    }
                }}
            >
                <DialogTitle>
                    <Grid container justifyContent="space-between">
                        {label}&nbsp;
                        {newDialog !== undefined &&
                            newDialog({ saveFn: updateSource })
                        }
                        <Grid item alignItems="center">
                            {element ?
                                <></>
                                : <ButtonGroup size="small">
                                    <Button disabled sx={{color: 'black'}}>
                                        Seleziona
                                    </Button>
                                    <Button onClick={handleSelectAll} variant="outlined" color="secondary" size="small">
                                        <CheckBox />
                                        tutti ({sourceList.length})</Button>
                                    <Button onClick={handleSelectFiltered} variant="outlined" color="secondary" size="small">
                                        <LibraryAddCheck />
                                        filtrati ({filteredList.length})</Button>
                                    <Button onClick={handleUnSelectAll} variant="outlined" color="secondary" size="small">
                                        <CheckBoxOutlineBlank />
                                        Nessuno </Button>
                                </ButtonGroup>}
                        </Grid>
                        <Grid item >
                            <ButtonGroup>
                                <Button onClick={() => setShowMode('grid')} variant={showMode === 'grid' ? 'contained' : 'outlined'} size="small">
                                    <GridView />
                                </Button>
                                <Button onClick={() => setShowMode('table')} variant={showMode === 'table' ? 'contained' : 'outlined'} size="small">
                                    <TableRows />
                                </Button>
                            </ButtonGroup>

                        </Grid>
                    </Grid>
                    <Grid container spacing={1} size="grow">
                        <Grid size={9} sx={globalstyles.sectionHeader}>
                            Elementi disponibili

                        </Grid>
                        <Grid size={3} sx={globalstyles.sectionHeader}>
                            Elemento selezionato

                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container>


                        {prefilterParam.map(f => (
                            <Grid key={f.param} item>
                                <ButtonGroup>
                                    <Button size="small" variant={preFilterSelected[f.param].length > 0 ? 'contained' : "outlined"} onClick={() => resetPreFilter(f.param)} sx={{ pr: 1, pl: 1, pt: 0, pb: 0, minWidth: '0', fontSize: '0.7em' }}>
                                        <FilterAlt />
                                        {f.param}
                                    </Button>

                                    {f.list.map((c, k) => (
                                        <Button size="small" key={k}
                                            variant={preFilterSelected[f.param].indexOf(c) >= 0 ? 'contained' : 'outlined'}
                                            onClick={() => updatePreFilter(f.param, c)}
                                        >
                                            {c}
                                        </Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                        ))}
                        <Grid size={9}>
                            <Box style={{ maxHeight: c_height, overflow: 'auto' }}>


                                {isLoading ?
                                    <LinearProgress />
                                    :
                                    renderElementSection()
                                }
                            </Box>
                        </Grid>
                        <Grid size={3}>
                            <Box style={{ maxHeight: c_height, overflow: 'auto' }}>
                                {element ?

                                    <Grid  sx={{ pb: "1px", pt: "1px", borderBottom: '1px solid darkgrey' }} size="grow">
                                        <MyRow renderRow={myRenderRow} element={selectedElements} />
                                    </Grid>
                                    :
                                    <>
                                        {selectedElements.map((_elem, k) => (
                                            <Grid container key={k} sx={{ pb: "1px", pt: "1px", borderBottom: '1px solid darkgrey', backgroundColor: isSimple ? isSelected(_elem) : isSelected(_elem[myIdParam]) ? 'lightblue' : '' }}>
                                                <Grid size="grow">
                                                    <MyRow renderRow={myRenderRow} element={_elem} />
                                                </Grid>
                                                <Grid size={1}>
                                                    <IconButton
                                                        onClick={() => handleChangeSelection(_elem)}
                                                        variant={isSimple ? isSelected(_elem) : isSelected(_elem[myIdParam]) ? 'contained' : 'outlined'}
                                                        size="small"
                                                        color="primary">
                                    <Check sx={{fontSize: '0.9em'}} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </>}
                            </Box>

                        </Grid>

                    </Grid>

                </DialogContent>
                <DialogActions>

                    <Grid item container>

                        <Grid item xs container>

                            <TextField
                                variant="outlined"
                                size="small"
                                helperText="separa varie ricerche con gli spazi"
                                sx={{ mr: 1 }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(ev) => setFilterText(ev.target.value.toLowerCase())} />
                            <Button onClick={() => setShowOnlyFilter((pv) => (!pv))} size="small">
                                {showOnlyFilter ?
                                    <CheckBox />
                                    :
                                    <CheckBoxOutlineBlank />
                                }
                                visualizza solo filtrati
                                {filteredList.length > 0 && <>
                                    ({filteredList.length})
                                </>}
                            </Button>
                            <Button onClick={() => setAutoSelect((pv) => (!pv))} size="small">
                                {autoSelect ?
                                    <CheckBox />
                                    :
                                    <CheckBoxOutlineBlank />
                                }
                                seleziona automaticamente
                            </Button>
                        </Grid>
                        <Grid item xs container alignItems="center" justifyContent="flex-end">

                            {!element &&
                                <Chip label={`${selectedElements && selectedElements.length} selezionati`} color="secondary" sx={{ mr: 1 }} />
                            }
                            <Button onClick={handleClose} color="secondary" variant="outlined" startIcon={<Close />}>Annulla</Button>
                            <Button onClick={handleSave} sx={{ backgroundColor: isEdited ? 'red' : '' }} variant="contained" startIcon={<Check />} endIcon={isEdited ? <Edit /> : <></>}>Conferma</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
})


